import React, {useState, useEffect} from "react";
import {Col, Row, Statistic} from "antd";
import CountUp from 'react-countup';
import {useStore} from "@/store/useStore";
import catalogueService from "@/services/catalogueService";

export const TotalAvailableSpaces = (props: any) => {
    const [startValue, setStartValue] = useState<number>(0);
    const [totalAvailableSpaces, setTotalAvailableSpaces] = useState<number>(0);
    const { useIncreasedContrastTheme, availableSpacesRegionId } = useStore();

    useEffect(() => {
        let isCancelled = false;

        const loadTotalAvailableSpacesAsync = async () => {
            const res = await catalogueService.loadTotalAvailableSpaces(availableSpacesRegionId);

            if (isCancelled) {
                return;
            }

            setTotalAvailableSpaces((currentTotalAvailableSpaces) => {
                setStartValue(currentTotalAvailableSpaces);
                return res || 0;
            });
        };
        
        loadTotalAvailableSpacesAsync();
        const timer = setInterval(() => {
            loadTotalAvailableSpacesAsync();
        }, 300000);

        return () => {
            isCancelled = true;
            clearInterval(timer);
        };
    }, [availableSpacesRegionId]);

    return (
        <>
            <Statistic 
                value={totalAvailableSpaces}
                formatter={(value) => <CountUp start={startValue} end={parseInt(value as string)} separator="" />}
                valueStyle={{color: useIncreasedContrastTheme ? `var(--main-color-black)` : `var(--main-color-white)`, fontFamily: 'e-Ukraine', fontSize: "clamp(48px, 8vw, 76px)", fontWeight: 700}}
            />
            <div style={{
                color: useIncreasedContrastTheme ? `var(--main-color-black)` : `var(--main-color-white)`, 
                fontSize: "clamp(12px, 2vw, 18px)", 
                position: "absolute", 
                whiteSpace: "nowrap", 
                right: 0, 
                bottom: '-20px'
            }}>
                кількість вільних місць
            </div>
        </>
    )
}
